import {
  FaArrowRight
} from "react-icons/fa";
import "./services-list.css";
import servicesData from "./servicesData";

const ServicesList = () => {
  return (
    <section className="services-list">
      <div className="services-list__container">
        {/* HEADER */}
        <div className="services-list__header">
          <span className="services-list__badge">Our Services</span>

          <h2 className="services-list__title">
            Digital Solutions Built for{" "}
            <span className="services-list__title-accent">Growth & Scale</span>
          </h2>

          <p className="services-list__subtitle">
            We design and develop premium digital products — from custom
            software to enterprise platforms — tailored to your business goals.
          </p>
        </div>

        {/* GRID */}
        <div className="services-list__grid">
          {servicesData.map((service) => (
            <div className="services-list__card" key={service.id}>
              <div className="services-list__icon">{service.icon}</div>

              <h3>{service.title}</h3>

              <p>{service.description}</p>

              <a href={service.link} className="services-list__link">
                Get Started <FaArrowRight />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesList;
